import * as d3 from 'd3';
import { colorScale } from '../shared/logsColorScale';
import { StackedLogs } from './StackData';

export class StackGenerator {
    _title: string;
    _yScale: any;
    _xScale: any;

    private _generator: any;

    constructor() {
        this._xScale = d3.time.scale()
            .nice();
        this._yScale = d3.scale.linear()
            .nice();
        this._generator = d3.svg.area<any>()
            .interpolate('step')
            .x(d => this._xScale(d.x))
            .y0(d => this._yScale(d.y0))
            .y1(d => this._yScale(d.y0 + d.y));
        this.render = this.render.bind(this);
        this.update = this.update.bind(this);
    }

    xDomain(value: [Date, Date]): this {
        this._xScale.domain(value)
            .nice();
        return this;
    }

    yDomain(value: [number, number]): this {
        this._yScale.domain(value)
            .nice();
        return this;
    }

    size(value: { width: number, height: number }): this {
        this._xScale.range([0, value.width]);
        this._yScale.range([value.height, 0]);
        return this;
    }

    update(selection: d3.Selection<any>) {
        selection
            .attr('d', d => this._generator(d.values))
            .style('fill', (d, i) => colorScale(d.name))
            // .style('fill', 'none')
            .style('stroke', (d, i) => colorScale(d.name))
            .style('opacity', 0.5);
    }

    render(selection: d3.selection.Update<StackedLogs>) {
        selection
            .exit()
            .remove();
        selection
            .enter()
            .append('path');
        this.update(selection);
    }
}
